import { Flex, Typography } from "antd";
import { CurrencyFlagRound } from "ui";
import { ProgressBar } from "ui/ProgressBar";
import { formatWithDecimals } from "utils";
import { ContractGridDto } from "interfaces";
import styles from "./ContractAmount.module.css";

interface ContractAmountProps {
  contract: ContractGridDto;
}

export const ContractAmount = ({ contract }: ContractAmountProps) => {
  const { fiatAmount, paidAmount, fiatCurrency } = contract;
  const isFrame = fiatAmount === 0;

  const getAmountText = () => {
    if (isFrame) {
      return `${formatWithDecimals(paidAmount)}${String.fromCharCode(8201)}${fiatCurrency} / Рамочный`;
    }
    return `${formatWithDecimals(paidAmount)}${String.fromCharCode(8201)}/ ${formatWithDecimals(
      fiatAmount
    )}${String.fromCharCode(8201)}${fiatCurrency}`;
  };

  return (
    <Flex gap="small" align="flex-start" className={styles.container}>
      <CurrencyFlagRound currency={fiatCurrency} squareBg backgroundColor={"bg-white"} />
      <Flex vertical gap="2px" className="flex-grow">
        <Typography.Text type="secondary">Оплачено по договору</Typography.Text>
        <Typography.Text>{getAmountText()}</Typography.Text>
        {!isFrame && <ProgressBar percent={(paidAmount / fiatAmount) * 100} />}
      </Flex>
    </Flex>
  );
};
